import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class CheckoutHelperObject extends BaseModel {
  /**
   * @var {?string}
   */
  paymentMethod;

  /**
   * @var {boolean}
   */
  stripeIsComplete;

  /**
   * @var {boolean}
   */
  paymentButtonIsLoading;

  /**
   * @var {boolean}
   */
  upliftTokenIsAvailable;

  constructor(model = {}) {
    super();

    this.paymentMethod = model.paymentMethod;
    this.stripeIsComplete = model.stripeIsComplete ?? false;
    this.paymentButtonIsLoading = model.paymentButtonIsLoading ?? false;
    this.upliftTokenIsAvailable = model.upliftTokenIsAvailable ?? false;
  }
}
